<template>
  <form role="form">
    <payout-form-group :label="$t('Номер карты')"
                       :required="model.isRequiredAttribute('cardNumber')"
                       :has-errors="model.errors.has('cardNumber')">
      <payout-cardnumber-input v-model="model.values.cardNumber"></payout-cardnumber-input>
      <payout-input-hint-block v-slot:hints :hint="model.getHint('cardNumber')"></payout-input-hint-block>
      <error-message-block v-slot:errors attribute="cardNumber|*" :errors="model.errors"></error-message-block>
    </payout-form-group>

    <payout-textfield-input-group :model="model" attribute="description"></payout-textfield-input-group>

    <payout-input-amount-form-group :model="model"></payout-input-amount-form-group>

    <payout-destination-currency-conversion-notice-form-group style="margin-top: 1em;"
                                              :model="model"></payout-destination-currency-conversion-notice-form-group>

    <payout-estimated-destination-amount-form-group :model="model"></payout-estimated-destination-amount-form-group>

    <payout-hint-panel-form-group :warning="true">
      <i18n path="nonUSDhint" tag="span">
        <template v-slot:CUR>USD</template>
      </i18n>
    </payout-hint-panel-form-group>

    <payout-evaluate-fee-form-group :model="model"></payout-evaluate-fee-form-group>

    <payout-form-notification-block :model="model"></payout-form-notification-block>

    <hr/>
    <payout-group-verification-type :model="model"></payout-group-verification-type>
  </form>
</template>

<script lang="ts">
import {Component} from "vue-property-decorator";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import PayoutTextfieldInputGroup from "@/components/forms/payout/PayoutTextfieldInputGroup.vue";
import PayoutInputAmountFormGroup from "@/components/forms/payout/PayoutInputAmountFormGroup.vue";
import PayoutEvaluateFeeFormGroup from "@/components/forms/payout/PayoutEvaluateFeeFormGroup.vue";
import PayoutFormNotificationBlock
  from "@/components/forms/payout/forms/PayoutFormNotificationBlock.vue";
import PayoutGroupVerificationType
  from "@/components/payout/verification/PayoutGroupVerificationType.vue";
import AbstractPayoutForm from "@/components/forms/payout/abstract/AbstractPayoutForm.vue";
import PayoutHintPanelFormGroup from "@/components/forms/payout/hint/PayoutHintPanelFormGroup.vue";
import {PaymentCodeEnum, PayoutWebModel} from "capitalist-shared/src/finance/payments";
import PayoutDestinationCurrencyConversionNoticeFormGroup
  from "@/components/forms/payout/crypto/PayoutDestinationCurrencyConversionNoticeFormGroup.vue";
import PayoutEstimatedDestinationAmountFormGroup
  from "@/components/forms/payout/forms/PayoutEstimatedDestinationAmountFormGroup.vue";
import PayoutCardnumberInput from "@/components/forms/payout/forms/PayoutCardnumberInput.vue";

export class KzCardsPayoutModel extends PayoutWebModel {
  systemName = PaymentCodeEnum.KazakhstanCards

  required = [
    "cardNumber",
    "amount",
    "currency",
    "description",
    "fromAccount",
    "verificationType",
  ]

  values = {
    cardNumber: "",
    amount: "",
    currency: "",
    description: "",
    fromAccount: "",
    verificationType: "",
  }
}

@Component({
  name: "KzCardsPaymentForm",
  components: {
    PayoutCardnumberInput,
    PayoutEstimatedDestinationAmountFormGroup,
    PayoutDestinationCurrencyConversionNoticeFormGroup,
    PayoutHintPanelFormGroup,
    PayoutGroupVerificationType,
    PayoutFormNotificationBlock,
    PayoutEvaluateFeeFormGroup,
    PayoutInputAmountFormGroup,
    PayoutTextfieldInputGroup, ErrorMessageBlock, PayoutInputHintBlock, PayoutFormGroup}
})
export default class KzCardsPaymentForm extends AbstractPayoutForm {
  model = new KzCardsPayoutModel()

}
</script>

<style scoped lang="less">

</style>


<i18n>
{
  "en": {
    "Номер карты": "Card number",
    "nonUSDhint": "In case of making a payment from a wallet other than {CUR}, a preliminary conversion to {CUR} will be performed."
  },
  "ru": {
    "nonUSDhint": "В случае оформления платежа с кошелька, отличного от {CUR}, будет произведена предварительная конвертация в {CUR}."
  }
}
</i18n>
